/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Redefine los built-ins como el legacy (los usan drone y drone13): variable por
// defecto ' ', sin helpUrl ni menú contextual de fábrica. No renombrar VAR/VALUE:
// dependen de ellos los proyectos guardados y los generadores.

Blockly.Blocks.variables_get = {
  init: function () {
    this.setColour(colors.COLOUR_VARIABLES);
    // Siempre pastilla: sin esto zelos lo dibuja hexagonal en una entrada Boolean.
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput('DUMMY')
      .appendField(Blockly.Msg.LANG_VARIABLES_GET)
      .appendField(new Blockly.FieldVariable(' '), 'VAR');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_VARIABLES_GET_TOOLTIP);
  },
};

Blockly.Blocks.variables_set = {
  init: function () {
    this.setColour(colors.COLOUR_VARIABLES);
    this.appendValueInput('VALUE')
      .appendField(Blockly.Msg.LANG_VARIABLES_SET)
      .appendField(new Blockly.FieldVariable(' '), 'VAR')
      .appendField(Blockly.Msg.LANG_VARIABLES_SET_AS)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_VARIABLES_SET_TOOLTIP);
  },
};
